<template>
  <div class="form-builder-field-error">
    <div v-if="!validationField[errorKey]"
         v-for="errorKey in Object.keys(validationField.$params)"
         class="error-msg">
      <span v-if="errors && errors && errors[errorKey]"> {{ errors[errorKey] }}</span>
      <span v-else-if="errorKey === 'required'">{{ fieldLabel.replace('*', '') }} {{ $t('common.isRequired') }}</span>
      <span v-else> {{ $t('common.somethingIsWrong') }}... </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormBuilderFieldError",
  props: {
    validationField: {
      type: Object
    },
    fieldLabel: {
      type: String
    },
    errors: {}
  }
}
</script>

<style lang="scss">
@import "FormBuilderFieldError";
</style>
